import { useRegistrationContext } from '../Registration.context';
import { RegistrationReferralCodeForm } from './RegistrationReferralCodeForm';
import { RegistrationReferralCodeInformation } from './RegistrationReferralCodeInformation';

export const RegistrationReferralCode = () => {
  const { showReferralCodeForm } = useRegistrationContext();

  return showReferralCodeForm ? <RegistrationReferralCodeForm /> : <RegistrationReferralCodeInformation />;
};
